import React, { ReactNode, useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import SHIP_TO_PARTY_GROUP_QUERY, {
  ShipToPartyGroupData,
} from 'shared/graphql/query/shipToPartyGroup';
import { Select, message } from 'antd';
import useMessageError from 'shared/hooks/useMessageError';
import _ from 'lodash';

type SelectshipToPartyProps = {
  value?: string;
  disabled?: boolean;
  checkData?: {
    stockSite?: string;
    item: {
      stockSite?: string | undefined;
      shipToParty?: string | undefined;
    }[];
  };
  onChange?: (values?: { shipToPartyId: string; shipToParty: string }) => void;
};

const { Option } = Select;

const SelectshipToParty: React.FC<SelectshipToPartyProps> = (props) => {
  const { value, disabled, onChange, checkData } = props;
  const [shipToPartyGroup, setShipToPartyGroup] = useState<
    {
      _id: string;
      shipToParty: string;
    }[]
  >([]);
  const { getMessageError } = useMessageError();

  const { data, loading, error } = useQuery<ShipToPartyGroupData>(SHIP_TO_PARTY_GROUP_QUERY, {
    onError: (err) => {
      message.error(getMessageError(err));
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (!loading && !error && data?.shipToPartyGroup) {
      const sortData = _.sortBy(data.shipToPartyGroup, ['shipToParty'], ['asc']);

      setShipToPartyGroup([...sortData]);
    }
  }, [data?.shipToPartyGroup, loading, error]);

  let ss: (string | undefined)[] = [];
  if (checkData?.stockSite) {
    ss = checkData?.item
      .filter((ele) => ele.stockSite == checkData?.stockSite)
      .map((ele) => ele.shipToParty || ele.stockSite);
  }

  const filtershipToParty = shipToPartyGroup.filter((item) => {
    return !ss.includes(item.shipToParty);
  });

  const options: ReactNode[] = filtershipToParty.map((item, index) => (
    <Option key={index} value={item._id}>{`${item.shipToParty}`}</Option>
  ));

  const onSelected = (valueInput: string) => {
    if (onChange && valueInput === undefined) {
      onChange(undefined);
    }

    const findShipToParty = shipToPartyGroup.find((item) => item._id === valueInput);
    if (onChange && findShipToParty) {
      const { _id, shipToParty } = findShipToParty;
      onChange({
        shipToPartyId: _id,
        shipToParty,
      });
    }
  };

  return (
    <>
      <Select
        style={{ width: '100%' }}
        allowClear
        value={value && options.length ? value : undefined}
        disabled={disabled}
        loading={loading}
        placeholder="เลือก ShipToParty"
        onChange={(valueChange) => onSelected(valueChange)}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) =>
          option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {options}
      </Select>
    </>
  );
};

export default SelectshipToParty;
